import React from "react";
import WantProductCard from "./WantProductCard";

const WantMenuSection = ({
  products,
  loading,
  onProductClick,
}) => {
  return (
    <section className="container mx-auto">

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500">Loading wanted listings...</p>
        </div>
      ) : products.length === 0 ? (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500">No wanted listings available.</p>
        </div>
      ) : (
        <div className="flex flex-col gap-4 w-full">

          {products.map((product) => (
            <WantProductCard
              key={product.id}
              product={product}
              onClick={() => onProductClick(product)}
            />
          ))}

        </div>
      )}

    </section>
  );
};

export default WantMenuSection;